module.exports = __webpack_public_path__ + "static/media/aws-academy-graduate-aws-academy-introduction-to-cloud-semester-1.42677bfc.png";